/* loaded by smart-asset */
export default require("./assets/pallet-split.i.svg")